import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { PlusIcon } from '../../../custom_shared/icons';
import { ButtonWithIcon } from '../../../custom_shared/components';
import { useAppStore } from '../../stores';
import { BalanceInformationNodeModel } from '../../models';
import './AddEntryCodeButton.less';

interface Props {
    node: BalanceInformationNodeModel;
}

const AddEntryCodeButton: React.FC<Props> = ({ node }) => {
    const { actionStore } = useAppStore();

    return (
        <div className="add-entry-code-button-container">
            <ButtonWithIcon
                label="Add entry code..."
                icon={<PlusIcon />}
                onClick={() => actionStore.addEntryCode(node.worksheetId, node.id)}
                disabled={node.worksheet.isLocked}
            />
        </div>
    );
};

export default observer(AddEntryCodeButton);
